import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-3bb44f1d"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["disabled", "placeholder", "aria-label"]

import { onMounted, ref } from "vue";
import cms from "../../services/cms/cms";
import { CmsDocumentTypes } from "../../services/cms/cms-type-definitions";
import { getTextBox, saveTextBox as saveTextBox } from "../../stores/smart-text-box-store";
import { TextBoxEntryApiModel } from "api-models";
import { csContext } from "../../services/cs-context";


export default /*#__PURE__*/_defineComponent({
  __name: 'cms-smart-text-box',
  props: {
    uid: {},
    placeholder: {},
    label: {}
  },
  setup(__props: any, { expose: __expose }) {

/* eslint-disable */
const props = __props;

const text = ref<string>("Loading...");
const loading = ref<boolean>(true);
const pixelHeight = ref<number>(100);

function textBoxState(): TextBoxEntryApiModel {
  return {
    authorId: csContext.user.id,
    subjectUserId: csContext.user.id,
    cmsType: "cms-smart-text-box",
    cmsId: "",
    cmsUid: props.uid ?? "",
    text: text.value,
  };
}

const blur = ref(() => saveThrottled(true));
const keyDown = ref((e: KeyboardEvent) => {
  if (e.key === "Enter" || e.key === "!" || e.key === "." || e.key === "?") {
    setTimeout(() => {
      saveThrottled(true);
    }, 100);
  } else {
    setTimeout(() => {
      saveThrottled(false);
    }, 100);
  }
});

let inputTimeout = null;

async function saveThrottled(rerunPrompts: boolean) {
  if (inputTimeout !== null) {
    return;
  }

  inputTimeout = setTimeout(async () => {
    inputTimeout = null;
    await saveTextBox(textBoxState(), rerunPrompts);
  }, 1000) as any;
}

onMounted(async () => {
  if (props.uid) {
    getTextBox(props.uid).then((value) => {
      text.value = value;
      loading.value = false;
    });

    const doc = await cms.getByUid(CmsDocumentTypes.CmsSmartTextBox, props.uid);
    pixelHeight.value = doc.data.height ?? 100;
  }
});

__expose({
  text,
});

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("textarea", {
    class: "form-control",
    id: "cms-smart-text-box",
    style: _normalizeStyle({ height: pixelHeight.value + 'px', zIndex: 99999, position: 'relative' }),
    disabled: loading.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((text).value = $event)),
    placeholder: props.placeholder,
    "aria-label": props.label ?? 'text box',
    rows: "3",
    onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (blur.value && blur.value(...args))),
    onKeydown: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (keyDown.value && keyDown.value(...args)))
  }, null, 44, _hoisted_1)), [
    [_vModelText, text.value]
  ])
}
}

})